import React from 'react'
import logo from 'assets/verdata_hires_logo.png'

import 'App.scss'
import './DeprecatedApp.scss'

export const NEW_APP_URL = 'https://app.myverdata.com'
export const SUPPORT_EMAIL = 'support@verdata.com'

/**
 * Full-page notice shown in place of the legacy application.
 *
 * This is rendered directly from index.jsx instead of <App />, so it is shown
 * before any login/session handling and for every URL path. Because no router
 * is mounted, there is no route a user can type to get around it.
 */
export default function DeprecatedApp() {
  return (
    <div className="deprecated-app" role="main">
      <section className="deprecated-app-card" aria-labelledby="deprecated-app-title">
        <img className="deprecated-app-logo" src={logo} alt="Verdata" />

        <h1 id="deprecated-app-title">This version of Verdata has been retired</h1>

        <p className="deprecated-app-message">
          This site is no longer available. Please use the new Verdata app at{' '}
          <a href={NEW_APP_URL}>app.myverdata.com</a> to continue your work.
          Your existing login works there.
        </p>

        <a className="button primary deprecated-app-cta" href={NEW_APP_URL}>
          Go to the new Verdata app
        </a>

        <p className="deprecated-app-support">
          Questions? Reach out to{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </p>
      </section>
    </div>
  )
}
